const mainImage = {
  src: 'https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/cae2b09559144955f026781d77a7bc9c.webp',
  alt: '焼きたてのピザ',
};

const galleryImages = [
  {
    src: 'https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/611ebfc4631b664e264d9c7ed209c502.webp',
    alt: 'レンガのピザ窯',
    span: '',
  },
  {
    src: 'https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/1b7c30f732675f8d009b4bfe5ea5a02b.webp',
    alt: '宇検村の海と山',
    span: '',
  },
  {
    src: 'https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/16125c5acb6a6eed69b953e93e3d8681.webp',
    alt: '生地を伸ばす',
    span: '',
  },
  {
    src: 'https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/68018e6ace22bd25345ad1e2cbe3bf0c.webp',
    alt: 'たんかんの木',
    span: '',
  },
  {
    src: 'https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/5b42effc9dc59a614a4a3b6b0bd4c4bc.webp',
    alt: 'ピザの箱を持って',
    span: 'col-span-2',
  },
  {
    src: 'https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/bae798f36131cc323c2554d8e9e83427.webp',
    alt: 'ソフトクリームと青空',
    span: '',
  },
  {
    src: 'https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/6868cf5d1dc997d73dccae1509379f47.jpeg',
    alt: 'お店の入口',
    span: '',
  },
];

export default function Gallery() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-6xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-tankan/10 text-tankan text-xs font-rounded font-bold tracking-widest px-3 py-1.5 rounded-full mb-4">
            / GALLERY
          </span>
          <h2 className="text-3xl md:text-4xl font-rounded font-black text-kiln">
            ふぅばてぇの風景
          </h2>
        </div>

        {/* Main image - スマホのみ全体表示 */}
        <div className="relative rounded-xl overflow-hidden group cursor-pointer mb-3 md:hidden">
          <img
            src={mainImage.src}
            alt={mainImage.alt}
            className="w-full h-auto block group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-kiln/0 group-hover:bg-kiln/20 transition-colors duration-300" />
        </div>

        {/* Sub Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 auto-rows-[200px]">
          {/* PC用メイン画像 - グリッド内に配置 */}
          <div className="hidden md:block relative rounded-xl overflow-hidden group cursor-pointer col-span-2 row-span-2">
            <img
              src={mainImage.src}
              alt={mainImage.alt}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-kiln/0 group-hover:bg-kiln/20 transition-colors duration-300" />
          </div>
          {galleryImages.map((img) => (
            <div
              key={img.alt}
              className={`relative rounded-xl overflow-hidden group cursor-pointer ${img.span}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-kiln/0 group-hover:bg-kiln/20 transition-colors duration-300" />
            </div>
          ))}
        </div>

        {/* Instagram CTA */}
        <div className="mt-10 text-center">
          <a
            href="https://www.instagram.com/nakamura0v0kensetsu.ukenson/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex flex-wrap justify-center items-center gap-2 border-2 border-kiln text-kiln font-rounded font-bold text-sm px-6 py-3 rounded-full cursor-pointer hover:bg-kiln hover:text-white transition-colors max-w-xs sm:max-w-none"
          >
            <i className="ri-instagram-line text-lg shrink-0" />
            <span className="text-center">もっと見る @nakamura0v0kensetsu.ukenson</span>
          </a>
        </div>
      </div>
    </section>
  );
}
